import { useEffect } from 'react';

/**
 * Sets the browser-tab title while the page is mounted and restores the
 * previous one on unmount, so the default title from index.html/admin.html
 * comes back after navigating away.
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
